const getters = {
  user: (state) => state.login.user,
  auth: (state) => state.login.auth,
  currentRoute: (state) => state.login.currentRoute,
  servicename: (state) => state.login.servicename,
  historyList: (state) => state.common.historyList,
  collapse: (state) => state.common.collapse,
  locale: (state) => state.common.locale
};
export default getters;